import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Events } from 'ionic-angular';
import { App } from 'ionic-angular/components/app/app';
import { VisitorProvider } from '../../providers/visitor/visitor';
import { TranslateService } from '@ngx-translate/core';
import { PermissionCheckPipe } from '../../pipes/permission-check/permission-check';
import { FacilityProvider } from '../../providers/facility/facility';

@IonicPage()
@Component({
  selector: 'page-pass-detail',
  templateUrl: 'pass-detail.html',
  providers: [PermissionCheckPipe]

})
export class PassDetailPage {

  colors = {
    cab: '#ed553b',
    delivery: '#20639b',
    guest: '#173f5f'
  }

  c = ['#ed553b', '#20639b', '#3caea3', '#f6d55c', '#173f5f']

  pass;
  screenshot;
  permissions: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private perPipe: PermissionCheckPipe,
    public events: Events,
    private translate: TranslateService,
    private visitorProvider: VisitorProvider,
    private facilityProvider: FacilityProvider,
    private app: App) {
    this.pass = this.navParams.get("passDetails");
    events.subscribe('user:created', (val) => {
      this.permissions = val.permissions;
    });

    this.getParkingDetails(this.pass.id)
    if ((this.perPipe.transform(this.permissions, 'GSTPRK', 'READ'))) {
      this.getParkingDetails(this.pass.id)
    }

    console.log(this.pass);
  }


  getParkingDetails(id) {
    this.facilityProvider.getParkingDetails(id).then(val => {
      if (val.data && val.status == 'success'){
        this.pass.parking_details= val.data
        console.log(this.pass)
      }
    })
 

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PassDetailPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/pass-detail/pass-detail.ts